// Lazy load components only when they're used on the page
// This improves initial page load performance

// Accordion
if (document.querySelector('drop-down') || document.querySelector('accordion-group')) {
  import('./accordion.js');
}

// Complementary Products
if (document.querySelector('complementary-products')) {
  import('./complementary-products.js');
}

// Featured Product Slider
if (document.querySelector('featured-product-slider')) {
  import('./featured-product-slider.js');
}

// Card Promo Text
if (document.querySelector('card-promo-text')) {
  import('./card-promo-text.js');
}

// Reveal Articles
if (document.querySelector('reveal-articles')) {
  import('./reveal-articles.js');
}

// Sticky ATC
if (document.querySelector('sticky-atc')) {
  import('./sticky-atc.js');
}

// Swym Wishlist
if (document.querySelector('swym-custom-wishlist')) {
  import('./swym-wishlist.js');
}

// Text Reveal
if (document.querySelector('text-reveal')) {
  import('./text-reveal.js');
}

// Featured Product Scroll
if (document.querySelector('featured-product-scroll')) {
  import('./featured-product-scroll.js');
}

// Product Card Slider
if (document.querySelector('product-card-slider')) {
  import('./product-card-slider.js');
}

// Lookbook Card - hover image swap on tap / keyboard
if (document.querySelector('lookbook-card')) {
  import('./lookbook-card.js');
}

// Quick Buy Size Slider on Product Card _ Load unconditionally to avoid timing issues with Nosto product cards
import('./slider-arrows.js');

// Quick Buy Feedback - Load unconditionally to avoid timing issues
import('./quick-buy-feedback.js');

// Collection Swatch Select - load unconditionally for dynamic content
import('./collection-swatch-selector.js');

// Carousel arrows for accessibility - load unconditionally
import('./carousel-accessibility.js');

// Announcement Bar Pause Button - for ADA compliance with moving content
if (document.querySelector('.announcement-bar__pause-button')) {
  import('./announcement-bar-pause.js');
}

// Cart Property Sync - syncs line-item properties with current product tags
if (document.querySelector('cart-drawer')) {
  import('./cart-property-sync.js');
}

// Stale Tab Refresh - refreshes the page when cart drawer opens after tab has been inactive
if (document.querySelector('cart-drawer')) {
  import('./stale-tab-refresh.js');
}

// Nosto PLP - reinsert marketing units, and reveal the server-rendered grid if
// Nosto never loads. The skeleton module is keyed off the durable target (not the
// <nosto-skeleton> element) so skeletons inserted by later facet re-renders still
// get their fallback even when the initial render had none.
if (document.querySelector('#nosto-target-plp')) {
  import('./nosto-marketing-units.js');
  import('./nosto-skeleton.js');
}

// Timeline Reveal is loaded in the footer (kept in assets folder)
